import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { RenderButton } from 'pages/payment-success/components/render-button'

import { ResultIcon, TYPE_RESULTS } from 'shared/ui/result-icon'

import styles from './styles.module.scss'

type Props = {
  onClick: () => void
}

export const ToursError = ({ onClick }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('safe-area-top-padding', styles.containerError)}>
      <div className={styles.icon}>
        <ResultIcon
          type={TYPE_RESULTS.ERROR}
          size={80}
        />
      </div>

      <p className={clsx(styles.text, 'semi-bold-16')}>
        {t('payment_success.error')}
      </p>

      <p className={clsx(styles.textDesc, 'medium-14')}>
        {t('payment_success.error_des')}
      </p>

      <RenderButton
        text={t('go_home')}
        onClick={onClick}
      />
    </div>
  )
}
